export const ErrorMessages = {
    NoLoggedInUserFound: "No logged in user found!",
    DonorNotFound: "Donor not found!",
    UserIdNotFound: "User ID not found!",
    DonationNotFound: "Donation not found!",
    MaxImageSizeExceed: "File must be less than 1MB!",
    InvalidTypeForImagePicker: "Please select only image!",
    APIAbortError: "Duplicate Call!",
    APIAbortRequest: "The user aborted a request.",
    InvalidAmountError: "Selected amount can not be more than 1000000000 in Bangladeshi taka",
};
